import { render, staticRenderFns } from "./AccountMenuEntry.vue?vue&type=template&id=2e0a74a6&scoped=true"
import script from "./AccountMenuEntry.vue?vue&type=script&lang=js"
export * from "./AccountMenuEntry.vue?vue&type=script&lang=js"
import style0 from "./AccountMenuEntry.vue?vue&type=style&index=0&id=2e0a74a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a74a6",
  null
  
)

export default component.exports